<script>
    import { randomChar } from '$lib/utils'
    export let id = randomChar(8)
    export let size = 24
    export let color = '#00669E'
    export let style = ''
    export let title = null
</script>

<svg
    width={`${size}`}
    height={`${size}`}
    {style}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    {#if title}
        <title>{title}</title>
    {/if}
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 12C0 12 5.37258 19 12 19C18.6274 19 24 12 24 12C24 12 18.6274 5 12 5C5.37258 5 0 12 0 12ZM19.8578 9.27864C20.7674 10.0116 21.5952 10.7989 22.323 11.5854C22.4564 11.7296 22.5812 11.8681 22.697 12C22.5812 12.1319 22.4564 12.2704 22.323 12.4146C21.5952 13.2011 20.7674 13.9884 19.8578 14.7214C17.3048 16.7787 14.6331 18 12 18C9.36693 18 6.69516 16.7787 4.14219 14.7214C3.23262 13.9884 2.40477 13.2011 1.67701 12.4146C1.54361 12.2704 1.41883 12.1319 1.30299 12C1.41883 11.8681 1.54361 11.7296 1.67701 11.5854C2.40477 10.7989 3.23262 10.0116 4.14219 9.27864C6.69516 7.22129 9.36693 6 12 6C14.6331 6 17.3048 7.22129 19.8578 9.27864ZM12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5ZM8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12Z"
        fill={color}
    ></path>
    <mask
        id="mask0_2522_{id}"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="5"
        width="24"
        height="14"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 12C0 12 5.37258 19 12 19C18.6274 19 24 12 24 12C24 12 18.6274 5 12 5C5.37258 5 0 12 0 12ZM19.8578 9.27864C20.7674 10.0116 21.5952 10.7989 22.323 11.5854C22.4564 11.7296 22.5812 11.8681 22.697 12C22.5812 12.1319 22.4564 12.2704 22.323 12.4146C21.5952 13.2011 20.7674 13.9884 19.8578 14.7214C17.3048 16.7787 14.6331 18 12 18C9.36693 18 6.69516 16.7787 4.14219 14.7214C3.23262 13.9884 2.40477 13.2011 1.67701 12.4146C1.54361 12.2704 1.41883 12.1319 1.30299 12C1.41883 11.8681 1.54361 11.7296 1.67701 11.5854C2.40477 10.7989 3.23262 10.0116 4.14219 9.27864C6.69516 7.22129 9.36693 6 12 6C14.6331 6 17.3048 7.22129 19.8578 9.27864ZM12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5ZM8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12Z"
            fill="white"
        ></path>
    </mask>
    <g mask="url(#mask0_2522_{id})">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0H24V24H0V0Z"
            fill={color}
        ></path>
    </g>
</svg>
